/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { getPhrase, updatePhrase } from 'services/actions/waranty_phrases_actions';

const WarantyPhrases = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const [phraseId, setPhraseId] = useState<number | null>(null);
  const [phrase, setPhrase] = useState<string | null>(null);

  const NEGATIVE = 1;
  const POSITIVE = 2;
  const NEGATIVE_WITH_VARIANT = 3;
  const NON_CLASSIFIABLE = 4;

  useEffect(() => {
    (async () => {
      const result = await getPhrase();
      setPhraseId(result.id);
      setPhrase(result.phrase);
    })();
  }, []);

  const classifyPhrase = (phraseStatus: number) => {
    (async () => {
      await updatePhrase(phraseId as number, phraseStatus);
      const result = await getPhrase();
      setPhraseId(result.id);
      setPhrase(result.phrase);
    })();
  };

  const loadPhrase = () => {
    (async () => {
      const result = await getPhrase();
      setPhraseId(result.id);
      setPhrase(result.phrase);
    })();
  };

  if (!profile.alfa_tester) return <div />;

  return (
    <div className="page-container p-4">
      {phrase && phraseId && (
        <>
          <h4>A frase a seguir demontra que a licitação possui seguro garantia?</h4>
          <span>
            <strong>Frase: </strong>
            {phrase}
          </span>
          <br />
          <span>
            <strong>Id: </strong>
            {phraseId}
          </span>
          <div className="row d-flex justify-content-around">
            <button
              className="btn btn-primary btn-sm mt-1"
              type="button"
              onClick={() => classifyPhrase(POSITIVE)}
            >
              Positivo
            </button>
            <button
              className="btn btn-primary btn-sm mt-1"
              type="button"
              onClick={() => classifyPhrase(NEGATIVE)}
            >
              Negativo
            </button>
            <button
              className="btn btn-primary btn-sm mt-1"
              type="button"
              onClick={() => classifyPhrase(NEGATIVE_WITH_VARIANT)}
            >
              Negativo (variação de garantia)
            </button>
            <button
              className="btn btn-primary btn-sm mt-1"
              type="button"
              onClick={() => classifyPhrase(NON_CLASSIFIABLE)}
            >
              Não classificável
            </button>
            <button
              className="btn btn-primary btn-sm mt-1"
              type="button"
              onClick={() => loadPhrase()}
            >
              Carregar outra frase
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default WarantyPhrases;
